import { takeLatest, put } from 'redux-saga/effects';

import { MANAGE_INSURANCES_ACTION_TYPES } from '../actions/manage-insurances-actions';

import { actions as editUserActions } from '../../profiles/edit-user';
import { actions as getUserDocuments } from '../../profiles/get-user-documents';
import { actions as getPatientInsurancesListActions } from '../requests/get-patient-insurances-list';
import { actions as checkInsuranceActions } from '../../appointmentForm/requests/check-insurance-eligibility';
import { actions as latestCheckInsuranceActions } from '../../appointmentForm/requests/latest-check-insurance-req';
import { actions as insuranceEligibilityManualActivationsActions } from '../../profiles/insurance-eligibility-manual-activations';

function* clearManageInsuranceRelatedDataWorker() {
  yield put(editUserActions.clear());
  yield put(insuranceEligibilityManualActivationsActions.clear());
  yield put(getUserDocuments.clear());
  yield put(checkInsuranceActions.clear());
  yield put(latestCheckInsuranceActions.clear());
  yield put(getPatientInsurancesListActions.clear());
}

export function* clearManageInsuranceRelatedData() {
  yield takeLatest(
    MANAGE_INSURANCES_ACTION_TYPES.CLEAR_MANAGE_INSURANCE_RELATED_DATA,
    clearManageInsuranceRelatedDataWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/clear-manage-insurance-related-data.js